// extracted by mini-css-extract-plugin
export default {"wrapper":"Messages_wrapper__uAZ41","wrapperMessages":"Messages_wrapperMessages__Ilabo"};